'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
require('backbone.stickit');
require('bootstrap-material-design');
const CommentItemView = require('communication/ui/comment/view/item');
const TaskListView = require('communication/ui/view/task/list-in-comment');
const AdditionalView = require('balus/ui/view/additional/index');
const PrimaryContextView = require('balus/ui/view/primary-context');
const Marked = require('balus/util/marked');
const TimelineListTemplate = require('balus/ui/template/timeline/timeline-list.hbs');
const PartialPageTemplate = require('framework/ui/partial-page/template/partial-page.hbs');

class PartialPageItemCollectionView extends Mn.CollectionView {
    /**
     * PartialPage(部分ページ) 内のコメント一覧を取り扱う CollectionView
     *
     * このCollectionViewで取り扱う1つの要素は、コメントの親コメント階層に対応している。
     * 返信コメントがある場合、親コメントのView内部で別途CollectionViewが生成されている。
     *
     * @param options {Object}
     * @param options.collection {ItemCollection}
     */
    constructor(options) {
        super(options);

        // this.childView = TimelineCommentView;
        this.childView = CommentItemView;

        this._context = this.getOption('context');
        this._channel = this.getOption('channel');
        this._marked = this.getOption('marked');
        this._commentLoader = this.getOption('commentLoader');
    }

    childViewOptions() {
        return {
            context: this._context,
            channel: this._channel,
            marked: this._marked,
            commentLoader: this._commentLoader,
            tagName: 'li',
            className: 'list-item timeline-list-item comment-list-item',
            TaskListView: TaskListView,
            AdditionalView: AdditionalView,
            PrimaryContextView: PrimaryContextView,
        };
    }

    childViewTriggers() {
        return {
            'comment:add': 'comment:add',
            'comment:reaction:add': 'comment:reaction:add',
            'comment:additional:add': 'comment:additional:add',
            'reply:comment': 'reply'
        };
    }

    get tagName() {
        return 'ul';
    }

    get className() {
        return 'list partial-page-item-collection-view';
    }

    onAddChild() {
        this.triggerMethod('comment:add');
    }

    /**
     * コメントkeyの要素を activate して、それ以外のコメント要素を deactivate する
     *
     * @param key {Key}
     */
    onChangeActivate(key, options={}) {
        this.children.each(childView => {
            childView.onChangeActivate(key, options);
        });
    }

    /**
     * コメントの key を含んだItem要素(親コメント側のDOM要素と、返信コメントのDOM要素)を返す
     *
     * @param key {Key}
     * @return {(jQuery|null)[]}
     */
    getCommentDOMByKey(key) {
        let parentView = null;
        let replyView = null;

        this.children.each(childView => {
            if (key.isEqual(childView.model.getKey())) {
                parentView = childView;
            }

            const replyCollectionView = childView.getChildView('reply');
            if (replyCollectionView) {
                replyCollectionView.children.each(replyChildView => {
                    if (key.isEqual(replyChildView.model.getKey())) {
                        parentView = childView;
                        replyView = replyChildView;
                    }
                });
            }
        });

        if (parentView || replyView) {
            return [parentView && parentView.$el, replyView && replyView.$el];
        } else {
            return null;
        }
    }
}

class PartialPageView extends Mn.View {
    /**
     * PartialPage(部分ページ)を表示する View
     *
     * PartialPage には、続きを読む(過去方向)、コメント一覧、続きを読む(現在方向)、の大きく３要素が存在している。
     * コメント一覧は、 PartialPageItemCollectionView が担っている。
     *
     * @param options {Object}
     * @param options.model {PartialPage}
     */
    constructor(options) {
        super(options);

        this._context = this.getOption('context');
        this._project = this._context.getProject();
        this._channel = this.getOption('channel');
        this._marked = this.getOption('marked');
        this._commentLoader = this.getOption('commentLoader');

        this.listenTo(this.model, 'change:pagination', this.refreshMoreDOMs);
        this.listenTo(this.model, 'change:smallSidePartialPage change:biggerSidePartialPage', () => {
            this.triggerMethod('partialPage:update');
        });
    }

    regions() {
        return {
            pageItems: {
                el: '.partial-page-items',
                replaceElement: true,
            }
        };
    }

    get template() {
        return PartialPageTemplate;
    }

    get className() {
        return 'partial-page-items';
    }

    childViewTriggers() {
        return {
            'comment:add': 'comment:add',
            'comment:reaction:add': 'comment:reaction:add',
            'comment:additional:add': 'comment:additional:add',
            reply: 'reply'
        };
    }

    events() {
        return {
            'click .prev-more': 'fetchPrevMore',
            'click .next-more': 'fetchNextMore',
        };
    }

    /**
     *
     * @return {jQuery}
     */
    getPrevMoreDOM() {
        return this.$('.prev-more');
    }

    getPrevMoreLoadingIconDOM() {
        return this.$('.prev-more .loading-icon');
    }

    /**
     *
     * @return {jQuery}
     */
    getNextMoreDOM() {
        return this.$('.next-more');
    }

    getNextMoreLoadingIconDOM() {
        return this.$('.next-more .loading-icon');
    }

    /**
     *
     * @return {jQuery}
     */
    getPartialPageItemsDOM() {
        return this.getChildView('pageItems').$el;
    }

    onRender() {
        /** @type {PartialPage} */
        const partialPage = this.model;

        this.showChildView('pageItems', new PartialPageItemCollectionView({
            collection: partialPage.itemCollection(),
            context: this._context,
            channel: this._channel,
            marked: this._marked,
            commentLoader: this._commentLoader,
        }));

        this.refreshMoreDOMs();
    }

    refreshMoreDOMs() {
        /** @type {PartialPage} */
        const partialPage = this.model;
        const pagination = partialPage.pagination();

        if (pagination.nextMore) {
            this.getNextMoreDOM().show();
        } else {
            this.getNextMoreDOM().hide();
            this.getNextMoreDOM().removeAttr('disabled');
            this.getNextMoreLoadingIconDOM().hide();
        }

        if (pagination.prevMore) {
            this.getPrevMoreDOM().show();
        } else {
            this.getPrevMoreDOM().hide();
            this.getPrevMoreDOM().removeAttr('disabled');
            this.getPrevMoreLoadingIconDOM().hide();
        }
    }

    fetchPrevMore() {
        this.getPrevMoreDOM().attr('disabled', 'disabled');
        this.getPrevMoreLoadingIconDOM().show();
        this.triggerMethod('fetchPrevMore', this.model);
    }

    fetchNextMore() {
        this.getNextMoreDOM().attr('disabled', 'disabled');
        this.getNextMoreLoadingIconDOM().show();
        this.triggerMethod('fetchNextMore', this.model);
    }

    onChangeActivate(key, options = {}) {
        this.getChildView('pageItems').onChangeActivate(key, options);
    }

    getCommentDOMByKey(key) {
        return this.getChildView('pageItems').getCommentDOMByKey(key);
    }

    show() {
        this.$el.show();
    }

    hide() {
        this.$el.hide();
    }
}

class CommentPartialPageCollectionView extends Mn.CollectionView {
    /**
     * CommentPartialPageCollection を取り扱う CollectionView
     *
     * PartialPage(部分ページ) が複数個連なっている。
     *
     * PartialPage間には「隣接している」「隣接していない」という異なる状態があり、
     * activeになっているコメントの属するページと、その隣接しているページだけが表示されるようになっている。
     *
     * activeになっているコメントが無いときには、最新のページと、最新ページに隣接しているページが表示される。
     *
     * @param options {Object}
     * @param options.collection {PartialPageCollection}
     */
    constructor(options) {
        super(options);

        this.childView = PartialPageView;
        this._activateItemKey = null;

        this.listenTo(this.collection, 'add', this.onChangeActivePages);
    }

    childViewOptions() {
        return {
            context: this.getOption('context'),
            channel: this.getOption('channel'),
            marked: this.getOption('marked'),
            commentLoader: this.collection.getCommentLoader(),
        };
    }

    childViewTriggers() {
        return {
            'comment:add': 'comment:add',
            'comment:reaction:add': 'comment:reaction:add',
            'comment:additional:add': 'comment:additional:add',
            reply: 'reply',
            fetchPrevMore: 'fetchPrevMore',
            fetchNextMore: 'fetchNextMore',
        };
    }

    childViewEvents() {
        return {
            'partialPage:update': 'onChangeActivePages'
        };
    }

    get className() {
        return 'partial-page-collection-view';
    }

    onAttach() {
        this.onChangeActivePages();
    }

    onChangeActivate(key, options = {}) {
        this._activateItemKey = key;

        this.children.each(childView => {
            childView.onChangeActivate(key, options);
        });

        // active化した key を含む PartialPage と、それに隣接した Page を表示して、それ以外の部分ページを非表示化する
        this.onChangeActivePages();
    }

    /**
     * key の item を含む PartialPage を返す
     * @return {PartialPage|null}
     */
    getActivePartialPage() {
        const key = this._activateItemKey;
        if (!key) {
            return null;
        }

        return _.find(this.collection.models, partialPage => {
            const itemCollection = partialPage.itemCollection();
            return _.find(itemCollection.models, comment => {
                if (comment.key.isEqual(key)) {
                    return true;
                }
                return _.find(comment.getReplyComments().models, replyComment => {
                    return replyComment.key.isEqual(key);
                });
            });
        }) || null;
    }

    onChangeActivePages() {
        const activePartialPage = this.getActivePartialPage();
        const latestPage = this.collection.getLatestPage();
        let activePartialPages = null;

        // active化した item を含む部分ページが見つかればその部分ページの、
        // 見つからなければ最新の部分ページに隣接するページ一覧を取得する
        if (activePartialPage) {
            activePartialPages = activePartialPage.seriesOfPages();
        } else if (latestPage) {
            activePartialPages = latestPage.seriesOfPages();
        }

        // 最新ページ部分か、途中ページ部分かによって、最新コメントへのジャンプバーの表示・非表示を切り替える
        const showingLatestPage = _.contains(activePartialPages, this.collection.getLatestPage());
        if (showingLatestPage || this.collection.isEmpty()) {
            this.triggerMethod('hideJumpToRecentMessage');
        } else {
            this.triggerMethod('showJumpToRecentMessage');
        }

        // active化した item を含むページとその隣接ページを表示し、それ以外のページを非表示化する
        this.children.each(childView => {
            const isVisible = activePartialPages == null || _.contains(activePartialPages, childView.model);
            if (isVisible) {
                childView.show();
            } else {
                childView.hide();
            }
        });
    }

    getCommentDOMByKey(key) {
        const childView = this.children.find(childView => {
            return childView.getCommentDOMByKey(key);
        });
        return childView && childView.getCommentDOMByKey(key);
    }

    getPageView(page) {
        return this.children.find(childView => {
            return childView.model === page;
        });
    }
}

class TimelineListView extends Mn.View {
    /**
     * コメントタイムラインのスクロール可能な領域全体を取り扱うView
     *
     * このViewがバインドされたDOMのスクロール位置を制御することになる。
     * このViewでスクロール位置調整などを行っている。
     *
     * childView として、 PartialPageCollection を描画する CollectionView を保持している。
     *
     * @param options
     * @param options.collection {PartialPageCollection}
     */
    constructor(options) {
        super(options);

        this._collection = options.collection;

        this._context = this.getOption('context');
        this._channel = this.getOption('channel');
        this._marked = Marked({});

        this._activeCommentKey = null;
        this._autoScrollToFocusInLoading = false;
        this._fitToBottom = false;
        this._scrollPosition = null;

        _.bindAll(this, 'onScroll');

        this.listenTo(this._collection, 'loading:start', () => {
            this._autoScrollToFocusInLoading = true;
        });
        this.listenTo(this._collection, 'loading:end', () => {
            // スクロール完了して一定時間経過してから、最後のスクロール位置調整を行う
            _.delay(
                (activeCommentKey) => {
                    this._autoScrollToFocusInLoading = false;
                    if (activeCommentKey) {
                        this.smartScrollToKey(activeCommentKey);
                    }
                },
                200 /* ms */,
                this._activeCommentKey
            );
        });
    }

    regions() {
        return {
            partialPages: {
                el: '.partial-page-collection',
                replaceElement: true,
            }
        };
    }

    get template() {
        return TimelineListTemplate;
    }

    get className() {
        return 'partial-pages';
    }

    childViewTriggers() {
        return {
            reply: 'reply',
            showJumpToRecentMessage: 'showJumpToRecentMessage',
            hideJumpToRecentMessage: 'hideJumpToRecentMessage',
        };
    }

    onRender() {
        this.showChildView('partialPages', new CommentPartialPageCollectionView({
            collection: this._collection,
            context: this._context,
            channel: this._channel,
            marked: this._marked,
        }));

        // showChildView を呼び出してから、実際にレンダリング完了するまで、多少の時間がかかるので、少し待ってからスクロールする
        _.delay(() => {
            // delayed scroll to bottom.
            this.scrollToBottom();
        }, 200 /* ms */);
    }

    onAttach() {
        this.getParentDOM().on('scroll', this.onScroll);
        this.restoreScrollPosition();
    }

    onDestroy() {
        this.getParentDOM().off('scroll', this.onScroll);
    }

    onScroll() {
        // fitToBottom は、一番下までスクロールした状態を維持するか否かのフラグ
        // DOM構造の変化などによって、スクロール位置がズレていたとしても、フラグを一定時間は保持する
        this._fitToBottom = this.positionIsBottom();
        this._scrollPosition = this.getParentDOM().scrollTop();

        if (!this._autoScrollToFocusInLoading) {
            this._activeCommentKey = null;
        }
    }

    restoreScrollPosition() {
        if (this._scrollPosition) {
            this.getParentDOM().scrollTop(this._scrollPosition);
        } else {
            this.scrollToBottom();
        }
    }

    childViewEvents() {
        return {
            'comment:add': 'autoScrollToFocus',
            'comment:reaction:add': 'autoScrollToFocus',
            'comment:additional:add': 'autoScrollToFocus',
            'fetchPrevMore': 'fetchPrevMore',
            'fetchNextMore': 'fetchNextMore'
        };
    }

    /**
     *
     * @param partialPage {PartialPage}
     */
    fetchPrevMore(partialPage) {
        // prev 方向のページ取得・追加時には、 DOM 構造的には下側への追加になる。

        // prev方向の page-more を表示できる位置ならば、 timeline DOM の最下部が表示されており、
        // fitToBottom を解除しておく (これが true のままだと、最下部までスクロール固定するようになってしまう)
        this._fitToBottom = false;

        // timeline DOM の現在の scrollTop を取得しておき、それを維持するように調整する
        const timelineDOM = this.getParentDOM();
        const scrollTop = timelineDOM.scrollTop();

        this._collection.fetchPrevPage(partialPage)
            .then(() => {
                timelineDOM.scrollTop(scrollTop);
            });
    }

    /**
     *
     * @param partialPage {PartialPage}
     */
    fetchNextMore(partialPage) {
        /** @type{CommentPartialPageCollection} */
        const collection = this._collection;

        const timelineDOM = this.getParentDOM();
        // タイムラインのスクロール量 = タイムラインの可視範囲の上端の位置
        const timelineVisiblePositionOfTop = timelineDOM.scrollTop();

        // 過去方向に読み進めようとしている基準ページの表示位置を取得する
        const partialPageView = this.getPageView(partialPage);
        const targetDOM = partialPageView.getPartialPageItemsDOM();
        const targetOffsetOfTop = targetDOM[0].offsetTop;
        // タイムラインDOMのスクロール量に対して、表示中のPartialPage要素の実際の表示位置までのオフセット
        const beforeVisibleOffset = targetOffsetOfTop - timelineVisiblePositionOfTop;

        collection.fetchNextPage(partialPage)
            .then(() => {
                const adjustScrollPosition = () => {
                    timelineDOM.scrollTop(targetDOM[0].offsetTop - beforeVisibleOffset);
                };
                adjustScrollPosition();
                if (this._autoScrollToFocusInLoading) {
                    this.on('adjustScrollPosition', adjustScrollPosition);
                    this._collection.once('loading:end', () => {
                        adjustScrollPosition();
                        this.off('adjustScrollPosition', adjustScrollPosition);
                    });
                }
            });
    }

    getParentDOM() {
        return this.$el.parent();
    }

    getBottomElementDOM() {
        return this.$('.timeline-bottom');
    }

    scrollToBottom() {
        this.getBottomElementDOM()[0].scrollIntoView();
        this._fitToBottom = true;
        window.bottomElement = this.getBottomElementDOM();
    }

    positionIsBottom() {
        const scrollTopPosition = this.getParentDOM().scrollTop();
        const visibleHeight = this.getParentDOM()[0].offsetHeight;
        const offsetTopOfBottomElement = this.getBottomElementDOM()[0].offsetTop;

        // 画像サイズが小数点以下のピクセル値になることがあるので、判定にはバッファをもたせる
        return scrollTopPosition + visibleHeight >= offsetTopOfBottomElement - 5;
    }

    autoScrollToFocus() {
        if (this._fitToBottom && !this._activeCommentKey) {
            // fitToBottom が設定されており、フォーカス対象のコメントKeyが未指定のときは、
            // 最新コメント位置までスクロールする
            this.scrollToBottom();
        } else if (this._autoScrollToFocusInLoading && this._activeCommentKey) {
            // ローディング中かつ、フォーカス対象のコメントKeyが指定されていれば、
            // そのコメント位置までスクロールする
            this.smartScrollToKey(this._activeCommentKey);
        } else {
            this.triggerMethod('adjustScrollPosition');
        }
    }

    onChangeActivate(key, options = {}) {
        this._activeCommentKey = key;
        this.getChildView('partialPages').onChangeActivate(key, options);
    }

    getPageView(page) {
        return this.getChildView('partialPages').getPageView(page);
    }

    smartScrollToKey(key) {
        const timelineDOM = this.getParentDOM();

        if (!timelineDOM || !timelineDOM[0]) {
            // タイムラインのDOMがすでに detach, destroy されている等
            return;
        }

        // タイムラインの表示部分の高さ
        const timelineVisibleHeight = timelineDOM[0].offsetHeight;

        // スクロールしようとしている対象コメントのDOM
        const targetDOMs = this.getChildView('partialPages').getCommentDOMByKey(key);
        if (!targetDOMs) {
            // 対象が見つからない時は return
            return;
        }

        const targetParentDOM = targetDOMs[0]; // 親コメントのDOM
        const targetChildDOM = targetDOMs[1]; // 返信コメントのDOM (対象Keyが返信コメントの場合のみ)
        // スクロールしようとしている対象のDOMの上端のタイムライン中の位置
        const targetOffsetOfTop = targetParentDOM[0].offsetTop;
        // 返信コメントの場合、親コメントのDOM基準でのオフセット分を取得する。返信コメントでない場合には 0 を返す
        const replyViewOffsetOfTop = targetChildDOM && targetChildDOM[0].offsetTop || 0;

        // 返信コメントの場合にはタイムラインの可視範囲の上端から60%、通常コメントの場合には上端から15%の位置に
        // 対象コメントの上端がくるように調整する
        const offsetRate = replyViewOffsetOfTop > 0 ? 0.6 : 0.15;
        const newOffsetOfVisibleArea = timelineVisibleHeight * offsetRate;
        const newScrollPosition = targetOffsetOfTop - newOffsetOfVisibleArea + replyViewOffsetOfTop;
        timelineDOM.scrollTop(newScrollPosition > 0 ? newScrollPosition : 0);
    }
}

module.exports = TimelineListView;



// WEBPACK FOOTER //
// ./balus/ui/view/timeline/list.js